Pixlee.module('VerticalApp', function(VerticalApp, App, Backbone, Marionette, $) {
    var _this = this,
        API;

    VerticalApp.on("start", function(options) {
        new VerticalApp.Show.Controller(options);
    });
});